<script>
  import { createEventDispatcher } from "svelte";
  import { Modal } from "sveltestrap";
  import { statusState } from "@/stores/index.js";

  const dispatch = createEventDispatcher();

  export let isOpen = false;
  export let toggle = () => false;
  export let fullscreen = false;
  export let size = "";
  export let onModelOpen = () => {};

  $: if (isOpen) {
    onModelOpen(isOpen);
  }

  $: if ($statusState.closeModal) {
    setTimeout(() => {
      toggle();
      $statusState.closeModal = false;
      dispatch("success");
    }, 2000);
  }
</script>

<Modal {isOpen} {toggle} {fullscreen} {size} backdrop="static">
  <slot />
</Modal>
